// extracted by mini-css-extract-plugin
export default {"head":"PricingFaqRowHead_head__b1V4-","question":"PricingFaqRowHead_question__+6A0q","dropdown":"PricingFaqRowHead_dropdown__6hK+y"};